import { useMemo } from "react";
import { Badge } from "@/components/ui/badge";
import { TID } from "@/constants/testIds";

export function ActionsTab({ actions, incidents }) {
  const byStatus = useMemo(() => {
    const groups = { open: [], in_progress: [], closed: [] };
    for (const a of actions) {
      const s = a.status || "open";
      (groups[s] || (groups[s] = [])).push(a);
    }
    return groups;
  }, [actions]);

  const incMap = useMemo(() => Object.fromEntries(incidents.map((i) => [i.id, i])), [incidents]);

  const Column = ({ title, tone, items }) => (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
      <div className={`text-xs uppercase tracking-wide font-semibold mb-3 ${tone}`}>{title} · {items.length}</div>
      <div className="space-y-2">
        {items.length === 0 && <div className="text-xs text-slate-400 text-center py-6">—</div>}
        {items.map((a) => (
          <div key={a.id} data-testid={TID.hseqActionRow(a.id)} className="rounded-md bg-white border border-slate-200 p-3">
            <div className="font-medium text-sm text-slate-900">{a.title}</div>
            <div className="text-xs text-slate-500 mt-1 line-clamp-2">{a.description}</div>
            <div className="flex items-center justify-between mt-2 text-xs">
              <span className="font-mono text-slate-500">{a.business_unit_code || "—"}</span>
              <Badge className={`text-[10px] ${a.priority === "high" ? "bg-rose-100 text-rose-700" : "bg-slate-100 text-slate-700"}`}>{a.priority}</Badge>
            </div>
            {a.incident_id && incMap[a.incident_id] && (
              <div className="mt-1.5 text-[10px] text-slate-400 font-mono truncate">
                ↳ {incMap[a.incident_id].ref_number}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="grid grid-cols-3 gap-4">
      <Column title="Open" tone="text-amber-800" items={byStatus.open || []} />
      <Column title="In Progress" tone="text-sky-800" items={byStatus.in_progress || []} />
      <Column title="Closed" tone="text-emerald-800" items={byStatus.closed || []} />
    </div>
  );
}
